import { InjectionToken } from '@angular/core';
export var CLIENT_MAP_WRAPPER = new InjectionToken('apollo/client-map-wrapper');
export var CLIENT_MAP = new InjectionToken('apollo/client-map');
//# sourceMappingURL=tokens.js.map


//////////////////
// WEBPACK FOOTER
// ./~/apollo-angular/build/src/tokens.js
// module id = 186
// module chunks = 4